import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { AiFillDelete } from "react-icons/ai";
import { server } from "../../../common";
import useQuickLook from "../../../quicklook/useQuickLook";
import { useSelectAccess } from "../../../store/stateFunctions";

const swalalert = withReactContent(Swal);

const InternshipsFromIndustry = () => {
  const user = useSelectAccess("Super Admin");
  const [data, setData] = useState([]);
  const displayFile = useQuickLook();
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");

  // Edit form data
  const [editFormData, setEditFormData] = useState({
    position: "",
    last_date: "",
    internship_description: "",
    internship_mode: "",
    company_name: "",
    location: "",
    internship_period: "",
    links: "",
    image: null,
    address: "",
    noofposition: "",
    skills: "",
  });

  useEffect(() => {
    getData();
  }, []);

  // Get
  const getData = () => {
    server
      .get("/internship/getallind_internship", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Delete
  const handleDelete = (data) => {
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.title} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/internship/deleteind_internship/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire(
                  "Deleted!",
                  "Internship has been deleted.",
                  "success"
                );
                getData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  // Open modal for confirmation
  const handleOpenModal = (blog, status) => {
    setSelected(blog);
    setSelectedStatus(status);
    setShowModal(true);
  };

  // Close modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelected(null);
    setSelectedStatus("");
  };

  // Update Status
  const updateStatus = async () => {
    try {
      await server.put(
        `/internship/update_approval_status/${selected.id}`,
        { status: selectedStatus },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: user.authToken,
          },
        }
      );
      toast.success("Internship Status Updated successfully");
      getData();
      handleCloseModal();
    } catch (error) {
      if (error instanceof AxiosError && error.response?.data?.message)
        toast.error(error.response.data.message);
      else if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("Failed to connect to the server");
        console.log(error.message);
      }
    }
  };

  // Edit internship
  const handleEdit = (selected) => {
    console.log("Selected object:", selected);
    setEditFormData({
      position: selected.position,
      last_date: selected.last_date,
      internship_description: selected.internship_description,
      internship_mode: selected.internship_mode,
      company_name: selected.company_name,
      location: selected.location,
      internship_period: selected.internship_period,
      links: selected.links,
      noofposition: selected.noofposition,
      address: selected.address,
      skills: selected.skills,
      image: null,
    });
    setShowEditModal(true);
    setSelected(selected); // Fix: Set selected, not data
  };

  // Close edit modal
  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setEditFormData({
      position: "",
      last_date: "",
      internship_description: "",
      internship_mode: "",
      company_name: "",
      location: "",
      internship_period: "",
      links: "",
      image: null,
      address: "",
      noofposition: "",
      skills: "",
    });
  };

  // Update internship details
  const handleUpdateInternship = async (e) => {
    e.preventDefault();

    // Check if selected is null or undefined
    if (!selected || !selected.id) {
      console.error("Invalid selected object or missing ID.");
      return;
    }

    try {
      const formData = new FormData();
      if (editFormData.image) {
        console.log("Image:", editFormData.image);
        formData.append("image", editFormData.image);
      }
      formData.append("position", editFormData.position);
      formData.append("last_date", editFormData.last_date);
      formData.append(
        "internship_description",
        editFormData.internship_description
      );
      formData.append("internship_mode", editFormData.internship_mode);
      formData.append("internship_period", editFormData.internship_period);
      formData.append("company_name", editFormData.company_name);
      formData.append("links", editFormData.links);
      formData.append("skills", editFormData.skills);
      formData.append("location", editFormData.location);
      formData.append("noofposition", editFormData.noofposition);
      formData.append("address", editFormData.address);
      formData.append("image", editFormData.image);

      server
        .put(`/internship/updateadminternship/${selected.id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: user.authToken,
          },
        })
        .then(function (response) {
          // formik.resetForm();
          getData();
          toast.success("Internship Updated successfully");
          handleCloseEditModal();
        })
        .catch(function (error) {
          if (error.response?.data?.message)
            toast.error(error.response.data.message);
          else if (error.response?.data?.error) {
            toast.error(error.response.data.error);
          } else toast.error("Failed to connect to server");
        });

      // Close the edit modal
      handleCloseEditModal();
      getData();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="container">
        <h2 className="text-center py-4">Internships From Industry</h2>
        <div className="row my-3">
          <div className="col-md-4">
            <input
              type="search"
              name=""
              className="form-control"
              placeholder="Search"
              id=""
            />
          </div>
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <select className="form-control" name="" id="">
              <option value="">Latest</option>
              <option value="">Last Month</option>
              <option value="">Last Year</option>
            </select>
          </div>
        </div>
        <div style={{ overflowX: "scroll" }}>
          <table className="table table-striped border">
            <thead>
              <tr>
                <th scope="col">Sr. No.</th>
                <th scope="col">Position</th>
                <th scope="col">Description</th>
                <th scope="col">Company Name</th>
                <th scope="col">Company Logo</th>
                <th scope="col">Address</th>
                <th scope="col">Internship Period</th>
                <th scope="col">Internship Mode</th>
                <th scope="col">Location</th>
                <th scope="col">Skills</th>
                <th>No Of Positions</th>
                <th scope="col">Status</th>
                <th></th>
                <th>Update</th>
                <th scope="col">Delete</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => {
                const statusOptions = {
                  Sent: ["Reviewed"],
                  Reviewed: ["Approved"],
                  Approved: ["Post"],
                  Post: ["Rejected"],
                  Rejected: ["Approved"],
                }[item.status];
                return (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td className="border">{item.position}</td>
                    <td className="border">{item.internship_description}</td>
                    <td className="border">{item.company_name}</td>
                    <td className="border">
                      <a href={item.image} target="_blank">
                        <img width="50" height="50" src={item.image} />
                      </a>
                    </td>
                    <td>{item.address}</td>
                    <td className="border">{item.internship_period}</td>
                    <td className="border">{item.internship_mode}</td>
                    <td className="border">{item.location}</td>
                    <td className="border">{item.skills}</td>
                    <td>{item.noofposition}</td>
                    <td className="border">{item.status}</td>
                    <td>
                      {statusOptions &&
                        statusOptions.map((option) => (
                          <button
                            key={option}
                            className="p-1 border-0 rounded-2 banner text-white"
                            onClick={() => handleOpenModal(item, option)}
                          >
                            {option}
                          </button>
                        ))}
                    </td>
                    <td>
                      <button
                        className="p-1 border-0 rounded-2 banner text-white"
                        onClick={() => handleEdit(item)}
                      >
                        Edit
                      </button>
                    </td>
                    <td className="border">
                      <div className="btn banner text-white">
                        <AiFillDelete onClick={() => handleDelete(item)} />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal for confirmation */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Status Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to update the status to {selectedStatus}?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="contained" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="success"
            className="ms-2"
            onClick={updateStatus}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for edit */}
      <Modal show={showEditModal} onHide={handleCloseEditModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Internship Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Form to edit internship details */}
          <form onSubmit={handleUpdateInternship}>
            <Row>
              <Col>
                <div className="form-outline mb-2">
                  <TextField
                    name="company_name"
                    margin="dense"
                    type="text"
                    placeholder="Company Name"
                    variant="outlined"
                    label="Company Name"
                    value={editFormData.company_name}
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        company_name: e.target.value,
                      })
                    }
                    fullWidth
                    required
                  ></TextField>
                </div>

                <div className="form-outline mb-2">
                  <TextField
                    name="internship_description"
                    margin="dense"
                    type="text"
                    placeholder="Description"
                    variant="outlined"
                    label="Internship Description"
                    value={editFormData.internship_description}
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        internship_description: e.target.value,
                      })
                    }
                    fullWidth
                    required
                  ></TextField>
                </div>
                <div className="form-outline mb-2">
                  <TextField
                    name="position"
                    margin="dense"
                    type="text"
                    placeholder="Internship Position"
                    variant="outlined"
                    label="Internship Position"
                    value={editFormData.position}
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        position: e.target.value,
                      })
                    }
                    fullWidth
                    required
                  ></TextField>
                </div>

                <div className="form-outline mb-2">
                  <TextField
                    name="internship_period"
                    margin="dense"
                    type="text"
                    placeholder="Internship Period"
                    variant="outlined"
                    label="Internship Period"
                    value={editFormData.internship_period}
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        internship_period: e.target.value,
                      })
                    }
                    fullWidth
                    required
                  ></TextField>
                </div>
                <div className="form-outline mb-2">
                  <TextField
                    name="links"
                    margin="dense"
                    type="text"
                    placeholder="Website Url"
                    variant="outlined"
                    label="Website Url"
                    value={editFormData.links}
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        links: e.target.value,
                      })
                    }
                    fullWidth
                    required
                  ></TextField>
                </div>
                <div className="form-outline mb-2">
                  <TextField
                    name="noofposition"
                    margin="dense"
                    type="text"
                    placeholder="Number of positions"
                    variant="outlined"
                    label="Number of positions"
                    value={editFormData.noofposition}
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        noofposition: e.target.value,
                      })
                    }
                    fullWidth
                    required
                  ></TextField>
                </div>
              </Col>
              <Col>
                <div className="form-group mb-2">
                  <TextField
                    name="last_date"
                    margin="dense"
                    type="date"
                    placeholder="Last Date"
                    variant="outlined"
                    label="Last Date of Application"
                    value={editFormData.last_date}
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        last_date: e.target.value,
                      })
                    }
                    InputProps={{
                      inputProps: {
                        min: new Date().toISOString().substring(0, 10),
                      },
                    }}
                    fullWidth
                    required
                    style={{ margin: "8px 0" }}
                    InputLabelProps={{ shrink: true }}
                  ></TextField>
                </div>
                <div className="mb-2">
                  <FormControl fullWidth required className="mt-2">
                    <InputLabel id="demo-simple-select-label">
                      Internship Mode
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Year"
                      variant="outlined"
                      name="internship_mode"
                      value={editFormData.internship_mode}
                      onChange={(e) =>
                        setEditFormData({
                          ...editFormData,
                          internship_mode: e.target.value,
                        })
                      }
                      required
                    >
                      <MenuItem value="online">Online</MenuItem>
                      <MenuItem value="offline">Offline</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="form-outline mb-2">
                  <TextField
                    name="location"
                    margin="dense"
                    type="text"
                    placeholder="location"
                    variant="outlined"
                    label="Location"
                    value={editFormData.location}
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        location: e.target.value,
                      })
                    }
                    fullWidth
                    required
                  ></TextField>
                </div>
                <div className="form-outline mb-2">
                  <TextField
                    name="image"
                    margin="dense"
                    type="file"
                    variant="outlined"
                    label="Company logo"
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <label htmlFor="image">Upload Image</label>
                        </InputAdornment>
                      ),
                      inputProps: {
                        accept: ".jpg, .png, .jpeg",
                        onChange: (e) => {
                          const selectedFile = e.target.files[0]; // Get the selected file
                          setEditFormData({
                            ...editFormData,
                            image: selectedFile,
                          });
                        },
                      },
                    }}
                  />
                </div>
                <div className="form-outline mb-2">
                  <TextField
                    name="skills"
                    margin="dense"
                    type="text"
                    placeholder="Skills"
                    variant="outlined"
                    label="Skills"
                    value={editFormData.skills}
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        skills: e.target.value,
                      })
                    }
                    fullWidth
                    required
                  ></TextField>
                </div>
                <div className="form-outline mb-2">
                  <TextField
                    name="address"
                    margin="dense"
                    type="text"
                    placeholder="Company Address"
                    variant="outlined"
                    label="Company Address"
                    value={editFormData.address}
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        address: e.target.value,
                      })
                    }
                    fullWidth
                    required
                  ></TextField>
                </div>
              </Col>
            </Row>
            <button
              className="p-1 border-0 rounded-2 banner text-white"
              type="submit"
            >
              Save Changes
            </button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default InternshipsFromIndustry;
